import React from 'react';

import boyFaceImg from './../../assets/images/clipart/boy-face.svg';
import girlFaceImg from './../../assets/images/clipart/girl-face.svg';
import nophoto from './../../assets/images/clipart/nophoto.png';

function Avatar(props) {
    return (
        <div className="avatar">
            <div className="avatar-box ">
                {/* <img src={boyFaceImg} className="avatar-box -img" /> */}
                <img className="avatar-box-img"
                    src={props && props.PhotoPath ?
                        props.PhotoPath.replace("?sv=2020-02-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2022-05-31T17:08:39Z&st=2021-04-06T09:08:39Z&spr=https&sig=bXyBXZatQS0ncOBkPb7Uw4FjpWY%2FXnOxgHUGZYhexgQ%3D", "").replace("?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2025-06-01T01:55:41Z&st=2022-05-31T17:55:41Z&spr=https,http&sig=4k7V748AsBkUQN8aR44sfuakzgLnuBPQJ879OhJ1I78%3D","").replace("?sv=2024-11-04&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2026-06-03T01:20:39Z&st=2025-06-02T17:20:39Z&spr=https&sig=xJNZmErdadXlEVrVpZpwwhHtfbNsMWaRGHijPUg3VlI%3D","")
                        : props && props.Gender  === 'Female' ? girlFaceImg
                            : props && props.Gender === 'Male' ? boyFaceImg
                                : nophoto
                    }
                    draggable={false}
                />
            </div>
        </div>
    )
}

export default Avatar;